import type { Config } from 'src/config';

export const CONFIG: Config =
  typeof window !== 'undefined' ? window.CONFIG : undefined;
